import { render, staticRenderFns } from "./addBanner.vue?vue&type=template&id=0b79818e&scoped=true"
import script from "./addBanner.vue?vue&type=script&lang=js"
export * from "./addBanner.vue?vue&type=script&lang=js"
import style0 from "./addBanner.vue?vue&type=style&index=0&id=0b79818e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b79818e",
  null
  
)

export default component.exports